var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 21h-4a6 6 0 0 1-6-6 1 1 0 0 1 2 0 4 4 0 0 0 4 4h4a4 4 0 0 0 0-8 1 1 0 0 1 0-2 6 6 0 0 1 0 12z",
    fill: "#23262f",
    opacity: 1,
    "data-original": "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 21A6 6 0 0 1 9 9h4a6 6 0 0 1 6 6 1 1 0 0 1-2 0 4 4 0 0 0-4-4H9a4 4 0 0 0 0 8 1 1 0 0 1 0 2z",
    fill: "#23262f",
    opacity: 1,
    "data-original": "#464646"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.173dabdf084706557b92a946e4c9c8ca.svg";
export { ForwardRef as ReactComponent };